import { useEffect, useState } from "react";

/**
 * Returns the Edit User Form Input fields component.
 *
 * @param {*} param0
 * @returns The Edit User Form Input fields component.
 */
const UserForm = ({ history, onSubmit, selectedUser, userHandleChange, authenticatedUser }) => {
  const [canEditUser, setCanEditUser] = useState(false);

  useEffect(() => {
    const isAuthUserSuperuser = authenticatedUser.is_superuser;
    const isSelectedUserSuperuser = selectedUser.is_superuser;
    setCanEditUser(isAuthUserSuperuser || !isSelectedUserSuperuser);
  }, [selectedUser, authenticatedUser]);

  const selectedUserPrecedence = selectedUser.is_superuser ? 3 : (selectedUser.is_staff ? 2 : 1);
  const authUserPrecedence = authenticatedUser.is_superuser ? 3 : (authenticatedUser.is_staff ? 2 : 1);

  return (
    <>
      <form>
        <div className="mt-6 grid grid-cols-4 gap-6">
          <div className="col-span-4 sm:col-span-2">
            <label htmlFor="fname" className="block text-base font-medium leading-6 text-gray-900">
              <span>First Name</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="firstName"
                id="fname"
                type="text"
                name="fname"
                placeholder="First Name"
                value={selectedUser.fname}
                onChange={userHandleChange}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="fname"
                name="fname"
                className="mt-2 block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-900 sm:text-base sm:leading-6"
              >
                {selectedUser.fname}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label htmlFor="lname" className="block text-base font-medium leading-6 text-gray-900">
              <span>Last Name</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="lastName"
                id="lname"
                type="text"
                name="lname"
                placeholder="Last Name"
                value={selectedUser.lname}
                onChange={userHandleChange}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="lname"
                name="lname"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.lname}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label htmlFor="email" className="block text-base font-medium leading-6 text-gray-900">
              <span>Email Address</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="email"
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                value={selectedUser.email}
                onChange={userHandleChange}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="email"
                name="email"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.email}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-1">
            <label htmlFor="expiration-date" className="block text-base font-medium leading-6 text-gray-900">
              <span>Research Field</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="research_field"
                id="research_field"
                name="research_field"
                placeholder="Research"
                onChange={userHandleChange}
                value={selectedUser.research_field}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="research_field"
                name="research_field"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.research_field}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-1">
            <label
              htmlFor="security-code"
              className="flex items-center text-base font-medium leading-6 text-gray-900"
            >
              <span>Research Location</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="research_geo"
                id="research_geo"
                name="research_geo"
                onChange={userHandleChange}
                placeholder="Research Location"
                value={selectedUser.research_geo}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="research_geo"
                name="research_geo"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.research_geo}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label htmlFor="country" className="block text-base font-medium leading-6 text-gray-900">
              <span>Institute</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="institute"
                id="institute"
                name="institute"
                placeholder="Institute"
                onChange={userHandleChange}
                value={selectedUser.institute}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="institute"
                name="institute"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.institute}
              </span>
            )}
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label htmlFor="phone_number" className="block text-base font-medium leading-6 text-gray-900">
              <span>Phone Number</span>
            </label>

            {selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub ? (
              <input
                data-cy="phone_number"
                id="phone_number"
                name="phone_number"
                onChange={userHandleChange}
                placeholder="Phone Number"
                value={selectedUser.phone_number}
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              />
            ) : (
              <span
                id="phone_number"
                name="phone_number"
                className="mt-2 block w-full rounded-md border border-gray-300 focus:border-blue-500 py-1.5 px-3 text-gray-900 shadow-sm focus:ring-1 outline-none placeholder:text-gray-400 focus:ring-inset focus:ring-blue-500 sm:text-base sm:leading-6"
              >
                {selectedUser.phone_number}
              </span>
            )}
          </div>

          {authenticatedUser.username !== selectedUser.sub && selectedUserPrecedence > authUserPrecedence && (
            <div className="col-span-4 sm:col-span-2">
              <label htmlFor="contributor_access" className="block text-base font-medium leading-6 text-gray-900">
                <span>Contributor Access</span>
              </label>

              <input
                data-cy="contributor_access"
                id="contributor_access"
                type="checkbox"
                name="contributor_access"
                className="mt-3 h-6 w-6 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                onChange={(e) => {
                  const newEvent = {
                    target: {
                      name: 'contributor_access',
                      type: 'checkbox',
                      checked: e.target.checked,
                    }
                  };
                  userHandleChange(newEvent);
                }}
                checked={selectedUser.contributor_access === true || selectedUser.contributor_access === "true"}
              />
              <span className="ml-2 text-sm text-gray-600">Allow user to submit datasets</span>
            </div>
          )}

          {selectedUserPrecedence > authUserPrecedence && authenticatedUser.username !== selectedUser.sub && (
            <div className="col-span-4 sm:col-span-1">
              <label htmlFor="edit_locked" className="block text-base font-medium leading-6 text-gray-900">
                <span>Disable Project Editing</span>
              </label>

              <input
                data-cy="edit_locked"
                id="edit_locked"
                type="checkbox"
                name="edit_locked"
                className="mt-3 h-6 w-6 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                onChange={userHandleChange}
                checked={selectedUser.edit_locked === "true"}
              />
            </div>
          )}

          {selectedUserPrecedence > authUserPrecedence && authenticatedUser.username !== selectedUser.sub && (
            <div className="col-span-4 sm:col-span-1">
              <label htmlFor="dv_approval_required" className="block text-base font-medium leading-6 text-gray-900">
                <span>Visualizations Require Approval</span>
              </label>

              <input
                data-cy="dv_approval_required"
                id="dv_approval_required"
                type="checkbox"
                name="dv_approval_required"
                className="mt-3 h-6 w-6 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                onChange={userHandleChange}
                checked={selectedUser.dv_approval_required === "true"}
              />
            </div>
          )}
        </div>

        <div className="flex justify-end gap-x-3 pt-8">
          {(selectedUserPrecedence > authUserPrecedence ||
            authenticatedUser.username === selectedUser.sub) && (
            <button
              data-cy="save"
              type="submit"
              onClick={onSubmit}
              className="inline-flex justify-center rounded-md bg-blue-600 py-2 px-3 text-base font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
              Save
            </button>
          )}

          <button
            type="button"
            onClick={() => history.push("/admin/user-management")}
            className="rounded-md bg-gray-200 py-2 px-3 text-base font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-gray-300"
          >
            Back
          </button>
        </div>
      </form>
    </>
  );
};

export default UserForm;
